export default "__VITE_ASSET__V47HoeQBgiUEQbXS1PpE9g__";